import { createTheme } from "@mui/material"
import defaultTheme from "./default"
import { grey } from "@mui/material/colors"

const lightTheme = createTheme( {
    theme: 'light',
    border: [
        "none",
        '1px solid #D7D7D7',
    ],
    table: {
        headerBg: "#d6d6d6",
        headerColor: '#3c3737',
        color: '#242527'
    },
    palette: {
        common: { font: "#000000", bg: "#ffffff" },
        mode: 'light',
        borderColor: "#D7D7D7",
        contentBg: "#f0f0f0",
        labelColor: '#797979',
        rowHover: "rgba(236, 236, 236, 1)",
        defaultColor: "#000",
        shadedText: "#373737",

        form: {
            formCardBg: "#fff",
            formBg: "#FCFCFC",
            placeholder: "#b3b3b3",
            inputBg: "#fff"
        },

        nav: {
            sidebar: "linear-gradient(90deg, #030034 25.54%, #0A009A 205.66%)",
            sidebarHover: "#FFFFFF1F",
            activeSidebarItem: "#EEBBC3",
            selected: "#151D48"
        },

        greyedOut: "#EFF6FF",
        layoutBackground: "#f7f7fa",
        background: { paper: "#fff", default: "#fff" },
        cardBackground: "#fff",
        contrastText: "#000",

        primary: {
            main: '#623f8f',
            light: '#834ec7',
            dark: '#442769',
            contrastText: '#ffffff'
        },
        primaryDark: {
            main: '#05004E',
            light: '#24327d',
            dark: '#101636',
            contrastText: '#fff'
        },
        error: {
            main: "#F44336",
            light: "#FF8D9D",
            dark: "#de5f71",
            contrastText: "#fff"
        },
        errorMessage: {
            main: "#F44336",
            light: "#FF8D9D",
            dark: "#de5f71",
            contrastText: "#fff"
        },
        customThemeColor: {
            main: "#E25A26",
            light: "#d4653b",
            dark: "#d94c16",
            contrastText: "#fff"
        },
        warning: {
            main: "#ffd600",
            dark: "#E2BC00",
            light: "#ffe800",
            contrastText: "#000"
        },
        greyed: {
            main: grey[500],
            light: grey[300],
            dark: grey[700],
            contrastText: "#fff"
        },
        text: {
            secondary: "#71717a",
            primary: "#09090b",
        },
    },
    shadows: [
        "none",
        "0px 2px 5px 0px #DBDBDBAB",
        ...defaultTheme.shadows.slice( 2 )
    ],
    typography: {
        fontFamily: "'Roboto', sans-serif",
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 600,
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: "10px"
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    border: "none"
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    background: "#fff"
                }
            }
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    padding: "0",
                    borderRadius: "5px"
                }
            }
        },
        MuiList: {
            styleOverrides: {
                root: {
                    padding: 0,
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        background: defaultTheme.palette.secondary.dark,
                        color: "#fff"
                    },
                    '&.Mui-selected:hover': {
                        background: defaultTheme.palette.secondary.dark + "dd",
                        color: "#fff"
                    }
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "capitalize"
                }
            }
        }
    }
} )

export default lightTheme